<template>
    <div class="item-question-block">
        <label class="text-color-questions text-block-questions mb-1"
            v-html="labelContent">
        </label>
        <p
            v-if="question.additionalInfo"
            class="fw-light form-input-help mb-1"
            v-html="question.additionalInfo"
        >
        </p>
    </div>
</template>

<script setup>
import { computed } from 'vue';

// INITIALIZE STORE & COMPOSABLES

// PROPS & EMITS
const props = defineProps({
    question: {
        type: Object,
        required: true,
    },
    TYPE_FIELD_ID: {
        type: Number,
        required: true,
    },
});

// REACTIVE VARIABLES

// COMPUTED PROPERTIES
const labelContent = computed(() => {
    return props.question.description;
});

// METHODS

// LIFECYCLE HOOKS
</script>
